import * as React from 'react';
import { Pane, PaneBackButton, PaneBody, PaneHeader, Page } from '../../atoms/applications/page';
import { ApplicationPageState } from '../../../containers/application/states/ApplicationPageState';
import { inject, observer } from 'mobx-react';
import { UserForm } from '../../molecules/applications/UserForm';

type Props = {
    applicationState: ApplicationPageState;
};

@inject('applicationState')
@observer
export class UserInfoPane extends React.Component<Props> {
    render() {
        const {
            applicationState: {
                canGoBack,
                userFormState,
                validateUserAndNext,
                submitState: { submitting },
            },
        } = this.props;
        return (
            <Page>
                <Pane>
                    {canGoBack && PaneBackButton}
                    <PaneHeader>会員情報の入力</PaneHeader>
                    <PaneBody>
                        <UserForm
                            submitting={submitting}
                            state={userFormState}
                            onSubmit={validateUserAndNext}
                            showPasswordFields={true}
                        />
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
